module.exports = __webpack_public_path__ + "static/img/BH.4a39c833.svg";